import React, { useEffect, useState } from 'react';
import { Checkbox } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditBillingShiftDifferentialRows,
  selectEditPayrollShiftDifferentialRows,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { shiftDifferentialModStyles } from '../ShiftDifferentialMod.style';
import { findIndex, findRow } from '../Utils';
import { modsEnums } from 'app/models/Placement/PlacementMods';
import { missingField } from 'app/constants';

interface GridCellProps {
  [key: string]: any;
}

export const EditWeekdayCell = (props: any) => {
  return (
    <>
      <EditWeekday cellParams={props?.cellParams} currentMod={props?.currentMod} />
    </>
  );
};

const EditWeekday = React.memo(function EditWeekday(params: GridCellProps) {
  const dispatch = useDispatch();
  const currentValue = params?.cellParams?.value;
  const [dayValue, setDayValue] = useState(currentValue === missingField ? null : currentValue);
  const { control } = useFormContext();
  const { classes } = shiftDifferentialModStyles({ isModEdit: false });
  const shiftDiffEditRequests =
    params?.currentMod === modsEnums.PayrollShiftDifferential
      ? useSelector(selectEditPayrollShiftDifferentialRows)
      : useSelector(selectEditBillingShiftDifferentialRows);

  useEffect(() => {
    const newValue = params.cellParams.row[params.cellParams.field];
    setDayValue(newValue);
  }, [params.cellParams.row.selectAll]);

  const rowId = params?.cellParams?.id;
  const areAllDayEquals = (checked, row) => {
    return (
      row.monday === checked &&
      row.tuesday === checked &&
      row.wednesday === checked &&
      row.thursday === checked &&
      row.friday === checked &&
      row.saturday === checked &&
      row.sunday === checked
    );
  };

  const setWeekdayForEdit = data => {
    let newRow = shiftDiffEditRequests.slice(0);
    const shiftDiffEditRow = findRow(params, shiftDiffEditRequests, rowId);
    const updatedCell = {
      ...shiftDiffEditRow,
    };
    const dayOfWeek = params.cellParams.field;
    updatedCell[dayOfWeek] = data.checked;
    const newSelectAll = areAllDayEquals(data.checked, updatedCell);
    updatedCell.selectAll = newSelectAll && data.checked ? 'Yes' : 'No';
    const editDateIndex = findIndex(updatedCell, params, shiftDiffEditRequests, rowId);
    newRow[editDateIndex] = updatedCell;
    switch (params?.currentMod) {
      case modsEnums.PayrollShiftDifferential: {
        dispatch(placementModsAction.setEditPayrollShiftDiffRows(newRow));
        break;
      }
      case modsEnums.BillingShiftDifferential: {
        dispatch(placementModsAction.setEditBillingShiftDiffRows(newRow));
        break;
      }
    }
  };

  return (
    <>
      <Controller
        name={`shiftDiffRequests${rowId}.${params.cellParams.field}`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <Checkbox
            checked={dayValue}
            value={dayValue}
            className={classes.switchLightBlue}
            onBlur={e => {
              setWeekdayForEdit(e.target);
              onChange(e.target.value);
            }}
            onChange={e => {
              onChange(e.target.checked);
              setWeekdayForEdit(e.target);
              setDayValue(e.target.checked);
              dispatch(placementModsAction.setCustomTemplateType(true));
              dispatch(placementModsAction.setOriginCustomTemplateChanged(true));
            }}
            {...rest}
          />
        )}
      />
    </>
  );
});
